import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=7dc3f13d&scoped=true"
import script from "./Sider.vue?vue&type=script&lang=js"
export * from "./Sider.vue?vue&type=script&lang=js"
import style0 from "./Sider.vue?vue&type=style&index=0&id=7dc3f13d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc3f13d",
  null
  
)

export default component.exports